import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';

import { CommonStyles } from '~commonInfra/styles/CommonStyles';

import { cssClass } from '../../../style';

const cssPrefix = 'BulkImportUserDialog';

export namespace BulkImportUserDialogStyle {

  export const fileInput = cssClass(cssPrefix, 'fileInput-area', {
    marginRight: '6px'
  });

/**
   * Drag and Drop Styles
   */
  export const dragAndDropContainer = cssClass(cssPrefix, 'file-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '150px',
    marginBottom: '8px'
  });

  export const dragAndDropChildren = cssClass(cssPrefix, 'inner-container', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    zIndex: 1, // Elevate children above ::after
  });

  export const defaultOutline = cssClass(cssPrefix, 'default-outline', {
    border: '2px dashed #ccc',
    position: 'relative',
    marginBottom: CommonStyles.Sizes.LargeSpace,
    $nest: {
      '&::after': {
        content: '""',
        position: 'absolute',
        left: '-1px',
        top: '-1px',
        right: '-1px',
        bottom: '-1px',
        border: '1px solid #fff'
      }
    }
  });

  export const handleFlexOverflow: NestedCSSProperties = {
    textAlign: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    minWidth: 0,
    width: '100%'
  };

  export const focusOutline = cssClass(cssPrefix, 'focus-outline', {
    backgroundColor: 'transparent',
    border: `2px solid ${TabStyles.Colors.Focus}`,
    boxShadow: `0 0 4px 0 ${TabStyles.Colors.Focus}`,
    outline: 'none'
  });

  export const activeOutline = cssClass(cssPrefix, 'active-outline', {
    border: `1px solid ${TabStyles.Colors.F5}`,
  });

  export const importDialog = cssClass(cssPrefix, 'bulkImportDialog', {
    position: 'relative',
    width: '500px',
    paddingBottom: CommonStyles.Sizes.RowHeight,
  });

  export const importForm = cssClass(cssPrefix, 'bulkImportForm', {
    marginBottom: CommonStyles.Sizes.DefaultSpace
  });

  export const fileName = cssClass(cssPrefix, 'file-name', {
    color: TabStyles.Typography.Color.PrimaryMedium,
    marginTop: 0,
    marginBottom: '30px',
    ...handleFlexOverflow
  });

  export const textField = cssClass(cssPrefix, 'text-field', {
    width: '100%',
    $nest: {
      '& input': {
        width: '100%'
      }
    },
    marginBottom: '30px',
  });

  export const dragAndDropText = cssClass(cssPrefix, 'drag-drop', {
    margin: 0,
    fontSize: '15px'
  });

  export const dragAndDropOrText = cssClass(cssPrefix, 'or', {
    margin: '8px 0',
    fontSize: '13px'
  });

  export const titleText = cssClass(cssPrefix, 'title', {
    fontFamily: 'BentonSans-Medium',
    fontSize: CommonStyles.Sizes.NormalFontSize,
  });

  export const bodyText = cssClass(cssPrefix, 'bodyText', {
    fontFamily: 'BentonSans-Book',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    color: TabStyles.Typography.Color.PrimaryMedium,
  });

  export const summaryText = cssClass(cssPrefix, 'bodyText', {
    marginLeft: '2px',
    fontFamily: 'BentonSans-Book',
    fontSize: CommonStyles.Sizes.NormalFontSize,
    color: TabStyles.Typography.Color.PrimaryMedium,
  });

  export const resultBody = cssClass(cssPrefix, 'resultBody', {
    borderWidth: CommonStyles.Sizes.LineWidth,
    borderStyle: 'solid',
    borderColor: CommonStyles.Colors.Grey178,
    height: '200px',
    overflowY: 'auto',
    marginTop: CommonStyles.Sizes.MediumSpace,
    marginBottom: CommonStyles.Sizes.LargeSpace,
  });

  export const resultUsername = cssClass(cssPrefix, 'resultUsername', {
    paddingBottom: CommonStyles.Sizes.MediumSpace,
    verticalAlign: 'top',
  });

  export const resultMessage = cssClass(cssPrefix, 'resultMessage', {
    paddingBottom: CommonStyles.Sizes.MediumSpace,
    verticalAlign: 'top',
    paddingRight: CommonStyles.Sizes.LargeSpace,
    width: '200px'
  });

}